import { IMask } from 'react-imask';
import moment from 'moment';
/**
 * Masks util.
 *
 * @author Mikhail Siutsou
 * @const MaskUtil
 * @category Utils
 */

var MaskUtil = {
  phoneMask: {
    mask: '+##################',
    definitions: {
      '#': /[0-9]/
    },
    minLength: 2,
    maxLength: 16,
    lazy: true,
    placeholderChar: 'X'
  },
  url: {
    mask: /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/
  },
  email: {
    mask: /^\S*@?\S*$/
  },
  positiveNumber: {
    mask: Number,
    definitions: {
      '#': /[\d\\.]/
    },
    lazy: true,
    scale: 0,
    signed: false,
    thousandsSeparator: ' ',
    normalizeZeros: true,
    min: 0,
    max: 100000000
  },
  positiveNumberFloat: {
    mask: Number,
    definitions: {
      '#': /[\d\\.]/
    },
    lazy: true,
    scale: 2,
    signed: false,
    thousandsSeparator: ' ',
    normalizeZeros: true,
    radix: ',',
    min: 0,
    max: 100000000
  },
  onlyPositiveDigital: {
    mask: Number,
    scale: 0,
    signed: false,
    normalizeZeros: true
  },
  time: {
    mask: Date,
    pattern: 'HH:mm',
    lazy: false,
    min: new Date(1970, 0, 1),
    max: new Date(2030, 0, 1),
    format: function format(date) {
      return moment(date).format('HH:mm');
    },
    parse: function parse(str) {
      return moment(str, 'HH:mm');
    },
    blocks: {
      HH: {
        mask: IMask.MaskedRange,
        from: 0,
        to: 23
      },
      mm: {
        mask: IMask.MaskedRange,
        from: 0,
        to: 59
      }
    }
  }
};
export { MaskUtil };